import { ISagaFunc } from 'services/actionConfigs';
import { ICreditCardSearchParams, ICreditCardSummary, ICreditCardTransaction } from './types';
import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { setPageLoading } from 'widgets/PageLoading';
import { AxiosResponse } from 'axios';
import { PaginatedList } from 'services/commonTypes';
import { actions } from './slice';
import creditCardApis from './apis';

const getCreditCardTransactions: ISagaFunc<ICreditCardSearchParams> =
  function* ({ payload }) {
    yield delay(200);
    setPageLoading(true);
    try {
      const res: AxiosResponse<{
        data: PaginatedList<ICreditCardTransaction>;
      }> = yield call(creditCardApis.get.creditCard, payload);
      yield put(actions.api.get.creditCard.success(res.data.data));
    } catch (error: any) {
      yield put(
        actions.api.get.creditCard.fail(
          error.response?.data?.message ||
            'Failed to fetch credit card transactions'
        )
      );
    } finally {
      setPageLoading(false);
    }
  };

  const getSummary: ISagaFunc<{ startDate: string; endDate: string }> =
  function* ({ payload }) {
    yield delay(200);
    setPageLoading(true);
    try {
      const res: AxiosResponse<{ data: ICreditCardSummary }> = yield call(
        creditCardApis.get.summary,
        payload
      );
      yield put(actions.api.get.summary.success(res.data.data));
    } catch (error: any) {
      yield put(
        actions.api.get.summary.fail(
          error.response?.data?.message ||
            'Failed to fetch credit card summary'
        )
      );
    } finally {
      setPageLoading(false);
    }
  };


export default function* sagas() {
  yield takeLatest(
    actions.api.get.creditCard.fetch.type,
    getCreditCardTransactions
  );
  yield takeLatest(actions.api.get.summary.fetch.type, getSummary);

}
